import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-contacts 217",
  "use": "icon-contacts 217-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-contacts 217\"><path d=\"M746.666667 170.666667a64 64 0 0 1 64 64v554.666666a64 64 0 0 1-64 64H320a64 64 0 0 1-64-64v-42.666666h-42.666667v-64h149.333334v64h-42.666667v42.666666h426.666667V234.666667H320v42.666666h42.666667v64h-149.333334v-64h42.666667v-42.666666a64 64 0 0 1 64-64h426.666667z m-56.597334 106.666666v469.333334h-64V277.333333h64zM320 384v256h-64V384h64z\" p-id=\"17039\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol